<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Concentrate all display alert messages here -->
<alert-display name="main"></alert-display>

<!-- Navigation -->
<fuse-vertical-navigation
    class="dark bg-primary-500 print:hidden"
    [appearance]="navigationAppearance"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation.default"
    [opened]="!isScreenSmall">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <!-- Logo -->
            @if (navigationAppearance === 'dense') {
                <div class="flex h-20 items-center justify-center">
                    <img
                        class="w-8"
                        src="images/logo/logo-on-dark.svg"
                        alt="Logo image">
                </div>
            } @else {
                <div class="flex items-center h-20 p-6 pb-0">
                    <img
                        class="w-auto ml-3"
                        src="images/logo/logo-text-on-dark.svg"
                        alt="Logo image">
                </div>
            }
    </ng-container>
    @if (!isScreenSmall) {
        <ng-container fuseVerticalNavigationFooter>
            <div class="flex p-4" [ngClass]="(navigationAppearance === 'dense') ? 'justify-center' : 'flex-row-reverse'">
                <button class="flex items-center justify-center border border-white text-white rounded-none bg-transparent hover:bg-primary-400 hover:border-white focus:outline-none"
                        (click)="toggleNavigationAppearance()">
                    <mat-icon class="text-white" [svgIcon]="navigationAppearance === 'default' ? 'heroicons_outline:chevron-left' : 'heroicons_outline:chevron-right'"></mat-icon>
                </button>
            </div>
        </ng-container>
    }
</fuse-vertical-navigation>

<!-- Loading overlay, todo extract to a component that works with the fuse loading bar -->
<div class="bg-accent-200"*ngIf="pageIsLoading" style="
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 10999;
    opacity: 0.4;"
>
</div>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">

    <!-- Header -->
    <div class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
        <!-- Navigation toggle button -->
        @if (isScreenSmall) {
            <button
                mat-icon-button
                (click)="toggleNavigation('mainNavigation')">
                <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
            </button>
        }
        <!-- Company tree toggle button -->
        <button
            mat-icon-button
            class="bg-gray-100"
            *ngIf="shouldDisplayTree"
            (click)="toggleCompanyTree()">
            <mat-icon class="text-primary-500" [svgIcon]="'mat_outline:account_tree'"></mat-icon>
        </button>
        <!-- image -->
         @if (this.companyStatus().hasCompany) {
            <button
                type="button"
                class="flex items-center ml-4 rounded cursor bg-transparent p-0 border-0"
                [ngClass]="companyData?.id === workingCompany?.company?.id ? 'cursor-pointer' : 'cursor-default'"
                [routerLink]="companyData?.id === workingCompany?.company?.id ? ['/settings/account'] : []"
                >
                <img
                    class="max-h-10 max-w-15 rounded"
                    [src]="workingCompany?.company?.imageURL || 'images/apps/company-image.png'"
                    [alt]="'Company logo' | transloco"
                />
            </button>
        }
        <label class="ml-2">
            {{ workingCompany?.name }}
        </label>
        <!-- Components -->
        <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
            <!--<languages></languages>-->
            <!--<shortcuts></shortcuts>-->
            <!--<messages></messages>-->
            <button class="underline hidden text-primary sm:inline-flex sm:mr-2" mat-button [matMenuTriggerFor]="beforeMenu">{{"How to add a device" | transloco}}</button>
                    <mat-menu class="center min-w-[500px]" #beforeMenu="matMenu" xPosition="before">
                        <div class="max-w-120">
                            <button mat-icon-button class="absolute top-2 right-2">
                                <mat-icon [svgIcon]="'mat_outline:close'"></mat-icon>
                            </button>
                            <app-doorwifi-advertisement>
                                <div title>
                                    {{ "Connect your devices with the" | transloco }}<span class='text-blue-600'> {{"Doorwifi app" | transloco}}</span>
                                </div>
                                <div body>
                                    {{ 'Use your Doorwifi application and follow the instructions to' | transloco }}
                                    <span class='font-semibold text-blue-600'>{{ 'link Manusa devices.' | transloco | lowerCamelCase }}</span>
                                    {{ 'When they are ready, they will appear in the list to manage them online.' | transloco }}
                                </div>
                            </app-doorwifi-advertisement>
                        </div>
                    </mat-menu>
            <notifications></notifications>
            <user></user>
            <!-- TODO Re-enable when sections are implemented.
            <secondary-menu></secondary-menu>
            -->
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto">

        <!-- Company tree container -->
       <div class="relative flex flex-auto w-full bg-card dark:bg-transparent">
            <mat-drawer-container class="flex-auto h-full"
                [hasBackdrop]="true">

                <mat-drawer
                    class="w-full sm:w-100 lg:border-r lg:shadow-none dark:bg-gray-900"
                    *ngIf="shouldDisplayTree"
                    [autoFocus]="false"
                    [(opened)]="drawerOpened"
                    (closedStart)="closeCompanyPanel()"
                    #drawer>

                    <ng-container>
                        <div class="relative h-full">
                            <company-tree
                                (actionSelected)="onTreeAction($event)"
                                (companyChanged)="closeCompanyPanel()" />

                            @if (companyPanelOpen) {
                                <div class="absolute inset-0 z-30 bg-white dark:bg-gray-900 lg:hidden">
                                    <company-tree-side-panel
                                        [mode]="companyPanelMode"
                                        [company]="selectedCompanyData"
                                        (closed)="closeCompanyPanel()"
                                        (actionSelected)="onTreeAction($event)"
                                        (generateLinkCode)="onGenerateLinkCode()" />
                                </div>
                            }
                        </div>
                    </ng-container>

                </mat-drawer>

                <mat-drawer-content class="flex overflow-hidden">
                    <div class="flex flex-auto flex-col items-center justify-center h-full w-full">
                        <router-outlet *ngIf="true"></router-outlet>
                    </div>
                </mat-drawer-content>
            </mat-drawer-container>

            @if (companyPanelOpen && !isScreenSmall) {
                <div class="absolute top-0 bottom-0 left-[400px] w-[420px] z-30 bg-white dark:bg-gray-900 border-l dark:border-gray-700 shadow-lg">
                    <company-tree-side-panel
                        [mode]="companyPanelMode"
                        [company]="selectedCompanyData"
                        (closed)="closeCompanyPanel()"
                        (actionSelected)="onTreeAction($event)"
                        (generateLinkCode)="onGenerateLinkCode()" />
                </div>
            }
        </div>

    </div>

    <!-- Footer -->
    <!--
    <div class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
        <span class="font-medium text-secondary">Doorwifi &copy; {{currentYear}}</span>
    </div>
    -->

</div>
